// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import NavTabs from '../../components/NavTabs';
import { TabNavLink, SpacerTab } from '../../components/TabStyles';
import { loadCommissionPayoutSettings } from './reducer';
import {
  CommissionPayoutsHeaderDiv,
  HeaderTextDiv
} from './CommissionPayoutsStyles';
import { formatCurrency } from '../../utilities/numberFormatting';
import { type Currency } from '../../utilities/types';
import { getPartnerCurrency } from '../../utilities/selectors';
import { PageHeaderP } from '../../components/PageHeaderStyles';

type Props = {
  partnerCurrency: Currency,
  loadCommissionPayoutSettings: () => void,
  midMonthMinimum: number,
  endMonthMinimum: number
};
class HeaderBlock extends Component<Props> {
  componentDidMount() {
    this.props.loadCommissionPayoutSettings();
  }
  headerText = () => (
    <HeaderTextDiv>
      <PageHeaderP>
        Commission payouts are calculated at the end of each month for each fiat
        currency in which more than{' '}
        {formatCurrency(this.props.endMonthMinimum, this.props.partnerCurrency)}{' '}
        in commissions are owed. If you reach{' '}
        {formatCurrency(this.props.midMonthMinimum, this.props.partnerCurrency)}{' '}
        in fiat commissions owed by the middle of the month then a payout will
        also be generated at this time.
      </PageHeaderP>
    </HeaderTextDiv>
  );
  render() {
    return (
      <CommissionPayoutsHeaderDiv>
        <NavTabs>
          <TabNavLink to="/commission-payouts/due">Commission Due</TabNavLink>
          <TabNavLink to="/commission-payouts/paid">Commission Paid</TabNavLink>
          <SpacerTab tablet />
        </NavTabs>
        <Route
          path="/commission-payouts/due"
          render={() => this.headerText()}
        />
        <Route
          path="/commission-payouts/paid"
          render={() => this.headerText()}
        />
      </CommissionPayoutsHeaderDiv>
    );
  }
}

const mapStateToProps = state => ({
  partnerCurrency: getPartnerCurrency(state),
  midMonthMinimum: state.commissionPayouts.index.midMonthMinimum,
  endMonthMinimum: state.commissionPayouts.index.endMonthMinimum,
  wireFee: state.commissionPayouts.index.wireFee
});

const mapDispatchToProps = {
  loadCommissionPayoutSettings
};

export default connect(mapStateToProps, mapDispatchToProps)(HeaderBlock);
